import { IonContent, IonPage, IonButton, IonHeader,IonImg, IonToolbar, IonIcon, IonText, getPlatforms } from '@ionic/react';
import { useHistory } from "react-router-dom";
import { remove } from '../services/storage.service';
import FooterComponent from "../components/FooterComponent";
import LoginCheck from "../components/LoginCheck";
import { logOutOutline, chevronBackOutline } from 'ionicons/icons';
import './Mindset.css';
import React from 'react';

const Analyze: React.FC = () => {
    const history = useHistory();
    function logOut(){
      console.log("logout");
      remove('cred');
      history.push('/home');
    }
    function viewFieldNotes(){
      history.replace('/viewfieldnote');
      window.location.reload();
    }

    
    return (
      <IonPage>
        <LoginCheck/>
        <IonHeader translucent={true} >
        <IonToolbar>
        <IonButton size="small" slot="start" color="primary" onClick={() => history.push("/dashboard/")} className="back"><IonIcon slot="start" icon={chevronBackOutline}/>Back</IonButton>
        <IonButton size="small" slot="end" color="primary" onClick={() => logOut()}  className="logout"><IonIcon slot="end" icon={logOutOutline}/>Log Out</IonButton>
        </IonToolbar>
      </IonHeader>
      
            <IonContent className="ion-text-center maintext headerimage">
              <IonText className="headerimage">
            <IonImg src="../assets/images/tablet/analyze-tablet.png" alt="Analyze" className="tablet-image hidden"/>
            <IonImg src="../assets/images/mobile/analyze-head-phone.jpg" alt="Analyze" className="phone-image"/>

            </IonText>
           <IonText className="topbrowntext"><p>How has an Explorer Mindset impacted your learning?</p>
            <p>Use this space to add field notes about your exploration</p></IonText>

              <IonButton routerLink="/createfieldnote" className="pagebutton" expand="block" size="default" shape="round">Create a field note</IonButton>
              <IonButton className="pagebutton"  expand="full" shape="round" onClick={()=>viewFieldNotes()}>View saved notes</IonButton>
              <IonText className="browntext">Be just as empowered by how you learn as what you learn</IonText>
              <IonImg src="../assets/images/analyze_footer_03.png" alt="analyzestripes"/>
        </IonContent>
      
        <FooterComponent/>
      </IonPage>
    );
  };

export default Analyze;